import PropTypes from "prop-types";
import { SECURITY_URL } from "../utilities/api";

// AICPA licence: the SOC logo may be resized only (height drives size, width stays auto).
const TrustBadges = ({ height = 48, className = "", linkClassName = "text-white" }) => (
  <div className={`flex flex-col items-center gap-1 ${className}`}>
    <div className="flex items-center justify-center gap-3">
    <a
      href="https://www.aicpa.org/soc4so"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex"
    >
      <img
        src="/images/aicpa-soc-logo.png"
        alt="AICPA SOC for Service Organizations logo"
        style={{ height: `${height}px`, width: "auto" }}
      />
    </a>
    <a
      href={SECURITY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex"
    >
      <img
        src="/images/hipaa-compliant-badge.svg"
        alt="HIPAA Compliant"
        style={{ height: `${height}px`, width: "auto" }}
      />
    </a>
    </div>
    <a
      href={SECURITY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`text-xs underline ${linkClassName}`}
    >
      Security &amp; Compliance
    </a>
  </div>
);

TrustBadges.propTypes = {
  height: PropTypes.number,
  className: PropTypes.string,
  linkClassName: PropTypes.string,
};

export default TrustBadges;
